import React, { Fragment } from "react";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import moment from "moment";
import GenericButton from "../../../UI/Button/Button";
import acceptAuthIcon from "../../../../../public/svg/tickAuthorizations.svg";
import rejectAuthIcon from "../../../../../public/svg/rejectAuthorizations.svg";
import { useSelector } from "react-redux";
import { getCurrentAccount } from "../../../../reducers/selectors";

import style from "./AuthorizationRow.scss";
import { FEATURE, isActionAllowed } from "../../../../utils/helper";

const AuthorizationRow = ({
  authItem,
  side,
  description,
  ammount,
  operationValue,
  currency,
  idx,
  onAuthorize,
  onReject,
  loading,
}) => {
  const currentAccount = useSelector(getCurrentAccount);

  const onAuthorizeWrapper = () => {
    onAuthorize(authItem);
  };

  const onRejectWrapper = () => {
    onReject(authItem);
  };

  return (
    <tr key={idx} className={style.tableRow}>
      <td className={style.sm}>
        <span className={style.tableTitleMobile}>Fecha</span>
        {moment(authItem.dateTime).format("DD MMM YYYY")}
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Tipo</span>
        {side}
      </td>
      <td>
        <span className={style.tableTitleMobile}>Instrumento</span>
        {description ? description : "-"}
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Precio</span>
        {+ammount === 0 ? (
          "-"
        ) : (
          <FormattedNumber
            value={ammount}
            minimumFractionDigits={currency === "GS" ? 0 : 2}
            maximumFractionDigits={currency === "GS" ? 0 : 2}
          />
        )}
      </td>
      <td className={style.sm}>
        <span className={style.tableTitleMobile}>Monto total a operar</span>
        <FormattedNumber
          value={operationValue}
          minimumFractionDigits={currency === "GS" ? 0 : 2}
          maximumFractionDigits={currency === "GS" ? 0 : 2}
        />
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Moneda</span>
        {currency}
      </td>
      <td className={style.actionButtons}>
        {isActionAllowed(FEATURE.AUTHORIZE, currentAccount) && (
          <Fragment>
            <GenericButton
              label={"Autorizar"}
              primary
              padding={"10px 10px 10px 6px"}
              backgroundColor={"#27272A"}
              loading={loading}
              width={"130px"}
              handleClick={onAuthorizeWrapper}
              iconSvg={[{ width: "24px", item: acceptAuthIcon }]}
            ></GenericButton>
            <GenericButton
              label={"Rechazar"}
              padding={"10px 10px 10px 6px"}
              backgroundColor={"#E4E4E7"}
              loading={loading}
              width={"130px"}
              textColor={"#27272A"}
              handleClick={onRejectWrapper}
              iconSvg={[{ width: "24px", item: rejectAuthIcon }]}
            ></GenericButton>
          </Fragment>
        )}
      </td>
    </tr>
  );
};

export default AuthorizationRow;
